<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 4155 4155"
       xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Vrstva_x0020_1">
    <circle class="fil0" cx="2078" cy="2078" r="2078"/>
     <path class="fil1"
           d="M1482 2773l1457 0c158,0 158,194 0,194l-1457 0c-158,0 -158,-194 0,-194zm1735 194l0 194 -2279 0 0 -194 0 -1892c0,-38 36,-81 67,-81l2146 0c31,0 66,43 66,81l0 1892zm-1735 -582l1457 0c158,0 158,194 0,194l-1457 0c-158,0 -158,-194 0,-194zm0 -388l1457 0c158,0 158,194 0,194l-1457 0c-158,0 -158,-194 0,-194zm0 -388l1457 0c158,0 158,194 0,194l-1457 0c-158,0 -158,-194 0,-194zm0 -388l1457 0c158,0 158,194 0,194l-1457 0c-158,0 -158,-194 0,-194z"/>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'GateDevice',
};
</script>

<style scoped>
.fil1 {
  fill: #FEFEFE
}

.fil0 {
  fill: #56D6D1
}
</style>
